import { Sidebar } from "@/components/Sidebar";

export const Layout = ({ title, subtitle, actions, children }) => {
  return (
    <div className="min-h-screen bg-[#F4F5F7]">
      <Sidebar />
      <div className="md:ml-64">
        <header className="sticky top-0 z-20 border-b border-[#E2E5EA] bg-white/70 px-6 py-4 backdrop-blur-xl md:px-8">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <h1 className="font-heading text-xl font-bold tracking-tight text-[#0F172A] md:text-2xl">
                {title}
              </h1>
              {subtitle && <p className="mt-0.5 text-sm text-[#9CA3AF]">{subtitle}</p>}
            </div>
            {actions && <div className="flex items-center gap-2">{actions}</div>}
          </div>
        </header>
        <main className="p-6 md:p-8">{children}</main>
      </div>
    </div>
  );
};
